"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapAlgoliaInitIndex = exports.wrapAlgoliaSearch = void 0;
/**
 * To avoid typo tolerance on numbers:
 * a. Separate by '-' first letter from number for code articles:
 *     - a code article 1st letter followed by a non-zero digit
 *     - a code article 1st letter followed by '.' or '*' and a number
 * b. code article is considered valid if it starts by L, R or D and contains
 * not more than 5 digits in its number till next separator
 * c. remove '°' used as number prefix e.g. n°
 */
var formatQuery = function (searchValue) {
    if (!searchValue) {
        return '';
    }
    if (searchValue.includes('"') || searchValue.toLowerCase().includes('lawlex')) {
        return searchValue;
    }
    return searchValue.replace(/°/g, ' ').replace(/\b([LRD])[.*]*([1-9]\d{0,4})\b/gi, '$1-$2');
};
var wrapAlgoliaSearch = function (search) {
    return function (queries, requestOptions) {
        return search(queries.map(function (fullQuery) {
            var _a;
            return (__assign(__assign({}, fullQuery), { params: __assign(__assign({}, fullQuery.params), { query: formatQuery((_a = fullQuery === null || fullQuery === void 0 ? void 0 : fullQuery.params) === null || _a === void 0 ? void 0 : _a.query) }) }));
        }), requestOptions);
    };
};
exports.wrapAlgoliaSearch = wrapAlgoliaSearch;
var wrapAlgoliaIndexSearch = function (search) {
    return function (query, requestOptions) {
        return search(formatQuery(query), requestOptions);
    };
};
var wrapAlgoliaInitIndex = function (initIndex) {
    return function (indexName) {
        var baseIndex = initIndex(indexName);
        return __assign(__assign({}, baseIndex), { search: wrapAlgoliaIndexSearch(baseIndex.search) });
    };
};
exports.wrapAlgoliaInitIndex = wrapAlgoliaInitIndex;
//# sourceMappingURL=wrapAlgoliaSearch.js.map